
import 'zone.js';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { SessionMonitorService } from './app/session/session-monitor.service';
import { UnhandledRejectionService } from './app/core/unhandled-rejection.service';

bootstrapApplication(AppComponent, appConfig).then(appRef => {
  const injector: any = (appRef as any).injector;
  const monitor = injector.get(SessionMonitorService); monitor.init();
  const rej = injector.get(UnhandledRejectionService); rej.init();
}).catch(err => console.error(err));
